import QueryResult from './QueryResult';
export default function DataFetcher(controller, completeCallback) {
  this.completeCallback = completeCallback ? completeCallback : function () {};
  this.async = true;
  this.controller = controller;
  this.searchers = [];
  this._isActive = true;
  this.onCancelHandlers = [];
  this.searcherStates = [];
  this.finalQueryResult = new QueryResult(null);
}

DataFetcher.prototype.fetch = function (queries) {
  var _this = this;

  //Do not move to async await. Needs to be parallel
  return new Promise(function (resolve) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var query = _step.value;
        var searcher = query.searcher;

        _this.searcherStates.push({
          "searcherId": searcher.getId(),
          "state": "pending"
        });

        searcher._fetchData(query).then(function (queryResult) {
          _this.fetchSuccess(queryResult);

          if (!_this.anyPending()) resolve(_this.finalQueryResult);
        }, function (error) {
          _this.fetchError(searcher, error);

          if (!_this.anyPending()) resolve(_this.finalQueryResult);
        });
      };

      for (var _iterator = queries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
};

DataFetcher.prototype.cancel = function () {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = this.onCancelHandlers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var onCancelHandler = _step2.value;
      onCancelHandler();
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  this.clean();
};

DataFetcher.prototype.clean = function () {
  if (this._isActive) {
    this._isActive = false;
    this.controller = null;
    this.onCancelHandlers = [];
    this.searcherStates = [];
    this.completeCallback([], true);
  }
};

DataFetcher.prototype.fetchSuccess = function (queryResult) {
  if (this._isActive) {
    var searcher = queryResult.getSearcher();
    var searcherId = searcher.getId();
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.searcherStates[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var searcherState = _step3.value;

        if (searcherState.searcherId == searcherId) {
          searcherState.state = "complete";
          searcherState.queryResult = queryResult;
          if (this.async) this.completeCallback(queryResult.getAllResults(), false);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    if (!this.anyPending()) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.searcherStates[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var thisSearcherState = _step4.value;

          if (thisSearcherState.state == "complete") {
            var result = thisSearcherState.queryResult;
            this.finalQueryResult.addNewQueries(result.getNewQueries());
            this.finalQueryResult.addResults(result.getResults());
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.completeCallback(this.finalQueryResult, true);
      this.clean();
    }
  }
};

DataFetcher.prototype.anyPending = function () {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = this.searcherStates[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var searcherState = _step5.value;
      if (searcherState.state === "pending") return true;
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return false;
};

DataFetcher.prototype.fetchError = function (searcher, errorThrown) {
  if (this._isActive) {
    var searcherId = searcher.getId();
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = this.searcherStates[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var searcherState = _step6.value;
        if (searcherState.searcherId == searcherId) searcherState.state = "error";
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    this.controller.fetchError(this, searcher, errorThrown);

    if (!this.anyPending()) {
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.searcherStates[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var thisSearcherState = _step7.value;

          if (thisSearcherState.state == "complete") {
            var result = thisSearcherState.queryResult;
            this.finalQueryResult.addNewQueries(result.getNewQueries());
            this.finalQueryResult.addResults(result.getResults());
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.completeCallback(this.finalQueryResult, true);
      this.clean();
    }
  }
};